/**
 * Created by Administrador on 25/04/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('classAvailabilityCtrl', classAvailabilityCtrl);

    classAvailabilityCtrl.$inject = ['tabs','type', 'userSession','datePickerService', 'dateService', 'classAvailabilityService', 'userService', 'excelService'];

    function classAvailabilityCtrl(tabs,type, userSession, datePickerService, dateService, classAvailabilityService, userService, excelService) {
        var vm = this;
        vm.tabs = tabs;
        vm.type = type;
        vm.isReport = false;
        vm.isGeneralOrRegional = userService.isGeneralOrRegional(userSession.data.positionType);
        vm.reportClassAvailabilityHtml = '';
        vm.datePickerOpenStatus = {
            fromDate: false,
            toDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerFromDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            },
            closed: function(args) {
                var dateAux = new Date(args.closeDate);
                var maxDate = new Date(dateAux.setDate(dateAux.getDate() + 29));
                vm.datepickerToDate.datepickerOptions.minDate = args.closeDate;
                vm.datepickerToDate.datepickerOptions.maxDate = maxDate;
            }
        };

        vm.datepickerToDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null,
                maxDate: null
            }
        };

        vm.filterTraffic = {
            fromDate: new Date(),
            toDate: null,
            detail: true
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.generate = function (isValid) {
            if(isValid) {
                var fromDate = dateService.dateTimeString(vm.filterTraffic.fromDate, 1);

                if(type=='flight'){
                    classAvailabilityService.getClassAvailabilityByFlight(fromDate, fromDate).then(function (response) {
                        vm.isReport = true;
                        vm.reportClassAvailabilityHtml = response.data;
                    });
                }else{
                    classAvailabilityService.getClassAvailabilityByConnection(fromDate, fromDate).then(function (response) {
                        vm.isReport = true;
                        vm.reportClassAvailabilityHtml = response.data;
                    });
                }

                //var toDate = dateService.dateTimeString(vm.filterTraffic.toDate, 2);

                /*if (vm.type === 'trafficOriginDestiny') {
                    statisticsService.getTrafficOriginDestiny(fromDate, toDate, vm.filterTraffic.detail).then(function (response) {
                        vm.isReport = true;
                        vm.reportTrafficHtml = response.data;
                    });
                } else if (vm.type === 'trafficByStages') {
                    statisticsService.getTrafficByStages(fromDate, toDate, vm.filterTraffic.detail).then(function (response) {
                        vm.isReport = true;
                        vm.reportTrafficHtml = response.data;
                    });
                }*/
            }
        }

        vm.generateToExcel = function (contendId) {
            excelService.exportDataToExcel(contendId, 'report_' + vm.type);
        }

        /*vm.generateTrafficPdfHtml = function (reportTrafficHtml) {
            printService.printPdfHtml(reportTrafficHtml);
        }

        vm.cancelGenerateTraffic = function(formGenerateTraffic) {
            vm.isReport = false;
            vm.datePickerOpenStatus.fromDate = false;
            vm.datePickerOpenStatus.toDate = false;
            vm.datepickerFromDate.minDate = null;
            vm.datepickerToDate.minDate = null;
            vm.datepickerToDate.maxDate = null;
            vm.filterTraffic.detail = true;
            vm.filterTraffic.fromDate = null;
            vm.filterTraffic.toDate = null;
            formGenerateTraffic.$setPristine();
        };*/
    }
})();
